import { FC } from 'react';
import CloudFrame from '../../../components/CloudFrame/CloudFrame';
import CloudFallback from '../../../components/CloudFrame/CloudFallback';

const CloudAIAgentSecurityPage: FC = () => (
    <div className="h-screen w-[calc(100vw-64px)] ml-16 bg-sf-white">
        <CloudFrame
            className="w-full h-full overflow-hidden"
            fallback={<CloudFallback />}
            srcRoute={`/silverfort/v1/ai-agents-security`}
        />
    </div>
);

export default CloudAIAgentSecurityPage;
